import { DateTimeField } from "@/components/site/DateTimeField";

export const DOC_FIELDS = [
  ["insurance_expiry", "Insurance expiry"],
  ["puc_expiry", "Pollution (PUC) expiry"],
  ["permit_expiry", "Permit expiry"],
  ["service_due", "Next service due"],
];

const btn = "mt-1 w-full rounded-md border border-white/10 bg-[#0A0A0A] px-3 py-2 text-sm";

export function CarDocDates({ f, set }) {
  return (
    <div data-testid="car-form-doc-dates">
      <p className="mb-2 text-sm font-semibold">Documents &amp; service</p>
      <p className="mb-3 text-xs text-neutral-400">You'll see a dashboard warning 30 days before any of these dates.</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {DOC_FIELDS.map(([k, label]) => (
          <div key={k} className="text-xs text-neutral-400">
            <div className="flex items-center justify-between">
              <span>{label}</span>
              {f[k] && <button type="button" onClick={() => set(k, "")} data-testid={`car-form-${k}-clear`} className="text-[11px] text-neutral-500 hover:text-rose-400">Clear</button>}
            </div>
            <DateTimeField value={f[k] || ""} onChange={(v) => set(k, v)} withTime={false} allowPast testId={`car-form-${k}`} className={btn} />
          </div>
        ))}
      </div>
    </div>
  );
}
